export default "__VITE_ASSET__CDZsA3VU__"